import {
    Box,
    DarkMode,
    Flex,
    HStack,
    Stack,
    StackDivider,
} from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useSelector } from 'react-redux';

import { useLayoutContext } from 'context/LayoutContext';

import { shouldShowWholesalerPaymentBanner } from '@/lib/data-router/hooks/useThemeHelper';
import { WHOLESALER_BANNER_HEIGHT_VAR } from '@/utils/layoutCssVars';
import SidebarNoRerender from './SidebarNoRerender';
import {
    SidebarAppVersion,
    renderThumb,
    renderTrack,
    renderView,
} from './index';

const Sidebar = () => {
    const { onMenuToggle, isMenuCollapse } = useLayoutContext();
    const { requiredScope, wholesalerPaymentBanner } = useSelector(
        (state) => state.login,
    );
    const isWholesalerPaymentBannerShow = shouldShowWholesalerPaymentBanner(
        requiredScope,
        wholesalerPaymentBanner,
    );

    // The sidebar is always rendered dark regardless of the app's light/dark
    // toggle (bg="dark.bgDark" below), so pin colorMode to 'dark' for this
    // subtree instead of spinning up a whole separate <ChakraProvider> — that
    // would fork its own ColorModeProvider, whose GlobalStyle writes a
    // competing `body { color }` rule to the real, shared <body>, fighting
    // the app's single live-synced top-level provider (see (2840)).
    return (
        <DarkMode>
            <Flex as="section" minH="100vh">
                <Stack
                    flex="1"
                    maxW={{
                        base: 'full',
                        sm: `${isMenuCollapse ? '64px' : '240px'}`,
                    }}
                    pt={{ base: '6', sm: '8' }}
                    pb={2}
                    justifyContent="space-between"
                    divider={
                        <StackDivider
                            aria-label="app-divider"
                            minW="213px"
                            mx="auto!important"
                            borderColor="dark.border"
                        />
                    }
                    bg="dark.bgDark">
                    {/* Main items section */}
                    <Flex
                        as={Scrollbars}
                        autoHide
                        autoHeightMax="670px"
                        renderTrackVertical={renderTrack}
                        renderThumbVertical={renderThumb}
                        renderView={renderView}>
                        <Stack
                            className="main-items"
                            spacing={
                                // (3101): mirror the banner's real height so
                                // it doesn't hide the top of the menu.
                                isWholesalerPaymentBannerShow
                                    ? `calc(var(${WHOLESALER_BANNER_HEIGHT_VAR}, 72px) + 32px)`
                                    : 8
                            }>
                            <Stack spacing={4} divider={<StackDivider />}>
                                <Box h={4} aria-label="menu-top-spacing" />
                            </Stack>
                            <Stack spacing="1" px={{ base: 4, sm: '6px' }}>
                                <SidebarNoRerender />
                            </Stack>
                        </Stack>
                    </Flex>

                    {/* App version section  */}
                    <Flex direction="column" className="app-version">
                        <HStack
                            spacing="3"
                            alignItems="center"
                            justify="space-between">
                            <SidebarAppVersion />
                        </HStack>

                        <Stack
                            spacing={1}
                            zIndex={99}
                            className={isMenuCollapse ? 'mr-0' : 'mr-1.5'}>
                            {/* Open/Collapse Menu */}
                            {/* <WrapItem
                                justifyContent="flex-end"
                                paddingInline={isMenuCollapse ? '1' : '0'}>
                                <Tooltip
                                    padding="6px"
                                    label={
                                        <SidebarTooltip
                                            isMenuCollapse={isMenuCollapse}
                                        />
                                    }
                                    hasArrow
                                    placement="right-end">
                                    <IconButton
                                        size="sm"
                                        aria-label="Show/Hide Menu"
                                        onClick={onMenuToggle}
                                        border="none"
                                        bg="none"
                                        _active={{ bg: 'none' }}
                                        _hover={{ bg: 'transparent' }}
                                        _focus={{ bg: 'transparent' }}
                                        color="white"
                                        icon={
                                            <ArrowLeftIcon
                                                sx={{
                                                    transform:
                                                        isMenuCollapse &&
                                                        'rotate3d(0, 1, 0, -180deg)',
                                                    transition: 'all .4s',
                                                }}
                                            />
                                        }
                                    />
                                </Tooltip>
                            </WrapItem> */}
                        </Stack>
                    </Flex>
                </Stack>
            </Flex>
        </DarkMode>
    );
};
export default Sidebar;
